export var NavigationAlignments;

(function (NavigationAlignments) {
  NavigationAlignments["Leading"] = "ALIGNMENTS/LEADING";
  NavigationAlignments["Trailing"] = "ALIGNMENTS/TRAILING";
})(NavigationAlignments || (NavigationAlignments = {}));

export var sidesheetDefaultValues = {
  navigationAlignment: NavigationAlignments.Leading,
  shouldUseDynamicPadding: false,
  panelWidths: {
    Mobile: '100vw',
    Tablet: '375px',
    Desktop: '480px',
    WideScreen: '560px',
    UltraWideScreen: '640px'
  }
};